import PropTypes from 'prop-types'
import styles from './styles'

/* A fake-ass browser for fake-ass website previews */
export default function FakeBrowser({ children }) {
  return (
    <div className={styles.FakeBrowser}>
      <div className={styles.TopBar}>
        <span className={styles.AddressBar}/>
      </div>
      <div className={styles.ViewPort}>
        {children}
      </div>
    </div>
  )
}

FakeBrowser.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/ThemeInfo/FakeBrowser/index.js